/** Strings owned by the clicker area. */
export const CLICKER_STRINGS = {
    // --- Clicker landing + per-farm page ---------------------------------------
    'clicker.title': { en: 'Clicker', ru: 'Кликер' },
    'clicker.title_farm': { en: 'Clicker — {farm}', ru: 'Кликер — {farm}' },
    'clicker.no_devices': { en: 'No devices online for this farm', ru: 'Нет устройств в сети для этой фермы' },
    'clicker.state_running': { en: 'running', ru: 'работает' },
    'clicker.state_online': { en: 'online', ru: 'в сети' },
    'clicker.state_offline': { en: 'offline', ru: 'не в сети' },
    // --- Per-farm clicker configuration ----------------------------------------
    'clicker.config_title': { en: 'Clicker configuration', ru: 'Настройка кликера' },
    'clicker.server_label': { en: 'Clicker server', ru: 'Сервер кликера' },
    'clicker.no_servers_hint': {
        en: 'No clicker servers configured yet — add one under the Clicker menu → Settings.',
        ru: 'Серверы кликера ещё не настроены — добавьте сервер в меню Кликер → Настройки.',
    },
    'clicker.bucket_code': { en: 'Bucket code', ru: 'Код bucket' },
    'clicker.operators_group': { en: 'Operators group', ru: 'Группа операторов' },
    'clicker.tg_chats': { en: 'Telegram chats (comma-separated)', ru: 'Telegram-чаты (через запятую)' },
    'clicker.tg_chats_short': { en: 'Telegram chats', ru: 'Telegram-чаты' },
    'clicker.operators_group_placeholder': { en: 'e.g. payout-group-1', ru: 'напр. payout-group-1' },
    'clicker.tg_chats_placeholder': { en: 'e.g. 12345, 67890', ru: 'напр. 12345, 67890' },
    'clicker.tg_proxy': { en: 'Telegram proxy', ru: 'Telegram-прокси' },
    'clicker.tg_proxy_no_team': {
        en: 'Assign this farm to a team to configure a proxy.',
        ru: 'Назначьте ферму команде, чтобы настроить прокси.',
    },
    'clicker.tg_proxy_hint': {
        en: 'Leave empty to notify Telegram directly.',
        ru: 'Оставьте пустым, чтобы писать в Telegram напрямую.',
    },
    // The Test button and its verdict line. The check is a real connection to
    // api.telegram.org through the proxy in the field, so the timing is worth showing:
    // a proxy that works but takes nine seconds is a proxy worth replacing.
    'clicker.tg_proxy_test': { en: 'Test', ru: 'Проверить' },
    'clicker.tg_proxy_testing': { en: 'Testing…', ru: 'Проверяю…' },
    'clicker.tg_proxy_ok': {
        en: 'Telegram answered in {ms} ms — bot {bot}',
        ru: 'Telegram ответил за {ms} мс — бот {bot}',
    },
    'clicker.tg_proxy_reached': {
        en: 'Telegram answered in {ms} ms, but: {note}',
        ru: 'Telegram ответил за {ms} мс, но: {note}',
    },
    'clicker.tg_proxy_failed': { en: 'Did not get through — {error}', ru: 'Не дозвонились — {error}' },
    'clicker.tg_proxy_format_title': { en: 'Format examples', ru: 'Примеры формата' },
    'clicker.tg_proxy_format_hint': {
        en: 'Must be a URL — any port. SOCKS5: socks5://user:pass@203.0.113.10:1080. HTTP: http://user:pass@203.0.113.10:8080, https:// also works. Drop “user:pass@” when the proxy needs no auth. A seller’s host:port:user:pass line is accepted as well, as long as you put the scheme in front: socks5://203.0.113.10:1080:user:pass.',
        ru: 'Нужен URL — порт любой. SOCKS5: socks5://user:pass@203.0.113.10:1080. HTTP: http://user:pass@203.0.113.10:8080, https:// тоже работает. Уберите «user:pass@», если прокси без авторизации. Строка продавца вида host:port:user:pass тоже принимается, если поставить схему впереди: socks5://203.0.113.10:1080:user:pass.',
    },
    // Not "Telegram language": the clicker writes its reports in this language everywhere
    // an operator reads them — the chat, the platform's admin panel and the registry — so
    // the field sits in Processing, not in the Telegram group.
    'clicker.notify_lang': { en: 'Report language', ru: 'Язык отчётов' },
    'clicker.notify_lang_hint': {
        en: 'Telegram reports, platform comments and the operations registry.',
        ru: 'Отчёты в Telegram, комментарии на платформе и реестр операций.',
    },
    'clicker.notify_lang_no_team': {
        en: 'Assign this farm to a team to choose a language.',
        ru: 'Назначьте ферму команде, чтобы выбрать язык.',
    },
    // Section headings + the marker on the two fields stored on the TEAM, not the farm.
    'clicker.group_processing': { en: 'Processing', ru: 'Обработка' },
    'clicker.group_telegram': { en: 'Telegram', ru: 'Telegram' },
    'clicker.group_limits': { en: 'Limits', ru: 'Лимиты' },
    'clicker.team_wide': { en: 'team-wide', ru: 'на команду' },
    'clicker.team_wide_title': {
        en: 'Team-wide setting — applies to every farm in team “{team}”',
        ru: 'Настройка уровня команды — применяется ко всем фермам команды «{team}»',
    },
    'clicker.lang_en': { en: 'English', ru: 'Английский' },
    'clicker.lang_ru': { en: 'Russian', ru: 'Русский' },
    'clicker.loop_pause': { en: 'Loop pause (sec)', ru: 'Пауза цикла (сек)' },
    'clicker.pause_invalid': {
        en: 'Pause must be a non-negative number',
        ru: 'Пауза должна быть неотрицательным числом',
    },
    'clicker.network_error': { en: 'Network error', ru: 'Ошибка сети' },
    // --- Per-device launch params ----------------------------------------------
    'clicker.task_type': { en: 'Task type', ru: 'Тип задачи' },
    'clicker.task_payout': { en: 'payout', ru: 'выплата' },
    'clicker.task_deposit': { en: 'deposit', ru: 'депозит' },
    'clicker.task_auto': { en: 'auto', ru: 'авто' },
    'clicker.select_app': { en: 'Select app', ru: 'Выберите приложение' },
    'clicker.payout_flow': { en: 'Flow', ru: 'Флоу' },
    'clicker.payout_flow_none': { en: 'no flows for this app', ru: 'нет флоу для этого приложения' },
    // Clicker caches (clicker-cache-modal.ts)
    'clicker.caches_title': { en: 'Clicker caches — {device}', ru: 'Кэши кликера — {device}' },
    'clicker.caches_hint': {
        en: 'State the clicker keeps between runs for this phone. Not available while the clicker is running.',
        ru: 'Состояние, которое кликер хранит между прогонами для этого телефона. Недоступно, пока кликер работает.',
    },
    'clicker.caches_account': { en: 'Own account number', ru: 'Номер своего счёта' },
    'clicker.caches_account_hint': {
        en: 'The phone\'s own account, cached after the first read. Clearing it makes the next run walk the detour that reads it again.',
        ru: 'Счёт самого телефона, закэшированный после первого чтения. После сброса следующий прогон снова пройдёт детур, который его читает.',
    },
    'clicker.caches_deposits': { en: 'Deposit and auto state', ru: 'Состояние депозитов и авто' },
    'clicker.caches_deposits_hint': {
        en: 'Processed-deposit cursors and the auto task\'s merchant flag. The deposit poller uses these to know what it has already credited — clear them only if you mean to cold-start it.',
        ru: 'Курсоры обработанных депозитов и флаг merchant у задачи auto. По ним поллер депозитов понимает, что уже зачислено — сбрасывайте, только если действительно нужен холодный старт.',
    },
    'clicker.caches_clear': { en: 'Clear caches', ru: 'Сбросить кэши' },
    'clicker.caches_clearing': { en: 'Clearing…', ru: 'Сброс…' },
    'clicker.select_an_app': { en: 'Select an app', ru: 'Выберите приложение' },
    'clicker.pin': { en: 'PIN', ru: 'PIN' },
    'clicker.app_password': { en: 'App password', ru: 'Пароль приложения' },
    'clicker.web_login': { en: 'Login', ru: 'Логин' },
    'clicker.web_login_ph': { en: 'Client number / user ID', ru: 'Номер клиента / ID пользователя' },
    'clicker.web_login_hint': {
        en: 'What the bank sign-in asks for besides the PIN ({LOGIN} in the flow): ING — the client number.',
        ru: 'Что банк спрашивает при входе помимо PIN ({LOGIN} во флоу): у ING — номер клиента.',
    },
    'clicker.app_password_placeholder': { en: 'for Ualá / Cenco / Ubi', ru: 'для Ualá / Cenco / Ubi' },
    'clicker.bucket_code_override_placeholder': {
        en: 'overrides farm bucket code',
        ru: 'переопределяет код bucket фермы',
    },
    'clicker.operators_group_override_placeholder': {
        en: 'overrides farm operators group',
        ru: 'переопределяет группу операторов фермы',
    },
    'clicker.tg_chats_override_placeholder': {
        en: 'overrides farm Telegram chats',
        ru: 'переопределяет Telegram-чаты фермы',
    },
    'clicker.start_clicker': { en: 'Start clicker', ru: 'Запустить кликер' },
    'clicker.stop_clicker': { en: 'Stop clicker', ru: 'Остановить кликер' },
    'clicker.stream_logs': { en: 'Stream logs', ru: 'Трансляция логов' },
    'clicker.operations_registry': { en: 'Operations registry', ru: 'Реестр операций' },
    'clicker.history': { en: 'Clicker history', ru: 'История кликера' },
    'clicker.pin_required': { en: 'PIN is required', ru: 'Укажите PIN' },
    'clicker.web_url': { en: 'Bank URL', ru: 'URL банка' },
    'clicker.web_url_ph': { en: 'https://www.ing.com.au/securebanking/', ru: 'https://www.ing.com.au/securebanking/' },
    'clicker.account_number': { en: 'Account number', ru: 'Номер аккаунта' },
    'clicker.account_number_ph': { en: 'CVU / UPI ID / IBAN', ru: 'CVU / UPI ID / IBAN' },
    'clicker.account_number_hint': {
        en: 'The account deposits arrive on. Empty — the clicker reads it in the app; set — this value is used.',
        ru: 'Счёт, на который приходят депозиты. Пусто — кликер читает его в приложении; задан — используется это значение.',
    },
    'clicker.lazy_label': { en: 'Lazy polling', ru: 'Ленивый опрос' },
    'clicker.lazy_hint': {
        en: 'Ask the platform first and open the bank only while it expects a deposit on this account (needs the account number). Off — read the bank every round.',
        ru: 'Сначала спрашивать платформу и заходить в банк только пока она ждёт депозит на этот счёт (нужен номер аккаунта). Выкл. — читать банк каждый круг.',
    },
    'clicker.web_url_required': { en: 'A bank URL (http:// or https://) is required', ru: 'Укажите URL банка (http:// или https://)' },
    'clicker.app_password_required': { en: 'App password is required', ru: 'Укажите пароль приложения' },
    'clicker.failed_to_start': { en: 'Failed to start', ru: 'Не удалось запустить' },
    'clicker.failed_to_stop': { en: 'Failed to stop', ru: 'Не удалось остановить' },
    'clicker.hint_stopping': {
        en: 'Stopping — waiting for the farm to confirm the run is over. The stop is re-sent by itself; pressing it again changes nothing.',
        ru: 'Останавливается — ждём от фермы подтверждения, что прогон завершён. Команда переотправляется сама, повторное нажатие ничего не изменит.',
    },
    'clicker.hint_set_pin': {
        en: 'Set a PIN and save before launching.',
        ru: 'Укажите PIN и сохраните перед запуском.',
    },
    'clicker.hint_not_configured': {
        en: 'Not configured — an admin must set a PIN before this device can launch.',
        ru: 'Не настроено — админ должен указать PIN, иначе устройство не запустить.',
    },
    // --- Reconfigure / info modals ---------------------------------------------
    'clicker.reconfigure_title': { en: 'Reconfigure clicker — {device}', ru: 'Перенастроить кликер — {device}' },
    'clicker.info_title': { en: 'Clicker — {device}', ru: 'Кликер — {device}' },
    'clicker.could_not_resolve_farm': { en: 'Could not resolve farm.', ru: 'Не удалось определить ферму.' },
    'clicker.running': { en: 'Running', ru: 'Работает' },
    'clicker.state_stopped': { en: 'stopped', ru: 'остановлен' },
    'clicker.min_initial_amount': { en: 'Min initial amount', ru: 'Мин. начальная сумма' },
    'clicker.max_initial_amount': { en: 'Max initial amount', ru: 'Макс. начальная сумма' },
    'clicker.min_balance': { en: 'Min balance', ru: 'Мин. баланс' },
    'clicker.max_balance': { en: 'Max balance', ru: 'Макс. баланс' },
    'clicker.app': { en: 'App', ru: 'Приложение' },
    'clicker.auto_detect': { en: 'auto-detect', ru: 'автоопределение' },
    'clicker.farm_default': { en: 'farm default', ru: 'значение фермы' },
    'clicker.logs': { en: 'Logs', ru: 'Логи' },
    'clicker.operations': { en: 'Operations', ru: 'Операции' },
    // --- Log window -------------------------------------------------------------
    'clicker.logs_title': { en: 'Clicker logs — {udid}', ru: 'Логи кликера — {udid}' },
    'clicker.log_filter_placeholder': { en: 'filter…', ru: 'фильтр…' },
    'clicker.autoscroll': { en: 'Autoscroll', ru: 'Автопрокрутка' },
    'clicker.log_lines_one': { en: '{count} line', ru: '{count} строка' },
    'clicker.log_lines_other': { en: '{count} lines', ru: '{count} строк' },
    'clicker.clear': { en: 'Clear', ru: 'Очистить' },
    // --- Amount fieldsets (payout bounds + deposit balance band) ----------------
    'clicker.payout_settings': { en: 'Payout settings', ru: 'Настройки выплат' },
    'clicker.deposit_settings': { en: 'Deposit settings', ru: 'Настройки депозитов' },
    'clicker.amount_min_initial_label': { en: 'Min initial amount (minors)', ru: 'Мин. начальная сумма (миноры)' },
    'clicker.amount_max_initial_label': { en: 'Max initial amount (minors)', ru: 'Макс. начальная сумма (миноры)' },
    'clicker.amount_min_balance_label': { en: 'Min balance (minors)', ru: 'Мин. баланс (миноры)' },
    'clicker.amount_max_balance_label': { en: 'Max balance (minors)', ru: 'Макс. баланс (миноры)' },
    'clicker.amount_non_negative': {
        en: '{label} must be a non-negative number',
        ru: '{label} должно быть неотрицательным числом',
    },
    'clicker.amount_min_exceeds_max': {
        en: '{min} cannot exceed {max}',
        ru: '{min} не может превышать {max}',
    },
    // --- Stop guard --------------------------------------------------------------
    'clicker.stop_blocked': {
        en: 'Started by {user} — only they or a senior operator can stop this clicker',
        ru: 'Запустил {user} — остановить может только он или старший оператор',
    },
    'clicker.confirm_stop': {
        en: 'Stop the clicker?\n\nA payout in progress will be closed as cancelled — the transfer may already have been sent.',
        ru: 'Остановить кликер?\n\nВыплата в процессе будет закрыта как отменённая — перевод мог уже уйти.',
    },
    'clicker.confirm_stop_on_device': {
        en: 'Stop the clicker on "{device}"?\n\nA payout in progress will be closed as cancelled — the transfer may already have been sent.',
        ru: 'Остановить кликер на «{device}»?\n\nВыплата в процессе будет закрыта как отменённая — перевод мог уже уйти.',
    },
};
